import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Contact = () => {
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    email: '',
    servico: '',
    mensagem: '',
    _gotcha: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nome || !formData.email || !formData.servico) {
      setError('Por favor, preencha os campos obrigatórios.');
      return;
    }

    if (formData._gotcha) {
      // Honeypot preenchido: comportamento típico de bot, ignora silenciosamente.
      navigate('/contato-enviado');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await fetch('https://formspree.io/f/mblgzkww', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        navigate('/contato-enviado');
      } else {
        setError('Erro ao enviar. Tente novamente.');
      }
    } catch (err) {
      setError('Erro de conexão. Verifique sua internet.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="bg-white text-darkblue1 py-20 px-6 md:px-10 font-cormorant">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-14 items-start">

        {/* Redes sociais / Info */}
        <motion.div
          className="space-y-6"
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl font-bold text-darkblue1 mb-4">Contato</h2>
          <p className="text-lg text-darkblue2 leading-relaxed">
            Fico feliz em receber sua mensagem! Você pode entrar em contato diretamente pelas redes sociais abaixo ou preencher o formulário.
          </p>

          <div className="space-y-4 text-lg">
            <a href="https://wa.me/13981682500?text=Gostaria%20de%20realizar%20uma%20consulta.%20Vim%20pelo%20site!" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-darkblue2 hover:text-darkred1 transition">
              <i className="fab fa-whatsapp text-2xl" /> WhatsApp
            </a>
            <a href="https://www.instagram.com/erivanfigueredo.psi/" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-darkblue2 hover:text-darkred1 transition">
              <i className="fab fa-instagram text-2xl" /> @erivanfigueredo.psi
            </a>
            <a href="mailto:contato@psicologaerivan.com.br" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-darkblue2 hover:text-darkred1 transition">
              <i className="fas fa-envelope text-2xl" /> contato@psicologaerivan.com.br
            </a>
            <a href="https://www.linkedin.com/in/erivan-figueredo-472935347/" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-darkblue2 hover:text-darkred1 transition">
              <i className="fab fa-linkedin text-2xl" /> LinkedIn
            </a>
            <a href="https://www.facebook.com/terapeutafamiliarecasal" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-darkblue2 hover:text-darkred1 transition">
              <i className="fab fa-facebook text-2xl" /> Facebook
            </a>
          </div>
        </motion.div>

        {/* Formulário */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <form onSubmit={handleSubmit} className="space-y-5">
            <h3 className="text-2xl font-semibold mb-2">Marque uma consulta</h3>

            <input
              type="text"
              name="_gotcha"
              value={formData._gotcha}
              onChange={handleChange}
              tabIndex="-1"
              autoComplete="off"
              aria-hidden="true"
              className="absolute -left-[9999px] w-px h-px overflow-hidden"
            />

            <label htmlFor="contact-nome" className="sr-only">Nome</label>
            <input id="contact-nome" type="text" name="nome" placeholder="Nome" value={formData.nome} onChange={handleChange} required className="w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-darkred1" />

            <label htmlFor="contact-telefone" className="sr-only">Celular (WhatsApp)</label>
            <input id="contact-telefone" type="text" name="telefone" placeholder="Celular (WhatsApp)" value={formData.telefone} onChange={handleChange} className="w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-darkred1" />

            <label htmlFor="contact-email" className="sr-only">Email</label>
            <input id="contact-email" type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required className="w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-darkred1" />

            <label htmlFor="contact-servico" className="sr-only">Serviço de interesse</label>
            <select id="contact-servico" name="servico" value={formData.servico} onChange={handleChange} required className="w-full border border-gray-300 rounded-md p-3 text-gray-600 focus:outline-none focus:ring-2 focus:ring-darkred1">
              <option value="">Por qual serviço você está interessada?</option>
              <option value="online">Psicoterapia Online</option>
              <option value="presencial">Psicoterapia Presencial</option>
              <option value="consultoria">Consultoria</option>
            </select>

            <label htmlFor="contact-mensagem" className="sr-only">Mensagem</label>
            <textarea id="contact-mensagem" name="mensagem" rows="4" placeholder="Mensagem" value={formData.mensagem} onChange={handleChange} className="w-full border border-gray-300 rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-darkred1" />

            {error && <p className="text-red-600 text-sm">{error}</p>}

            <button type="submit" disabled={loading} className="bg-darkred1 hover:bg-darkred2 text-white px-6 py-3 rounded-md text-lg font-semibold transition shadow-md">
              {loading ? 'Enviando...' : 'Enviar Mensagem'}
            </button>
          </form>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
